import { render, staticRenderFns } from "./textbox.vue?vue&type=template&id=5e64e47f&scoped=true&"
import script from "./textbox.vue?vue&type=script&lang=ts&"
export * from "./textbox.vue?vue&type=script&lang=ts&"
import style0 from "./textbox.vue?vue&type=style&index=0&id=5e64e47f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64e47f",
  null
  
)

export default component.exports